import HeaderMenu from '../components/headerMenu'
import '@/styles/errorPage.css'
import { LinkButton } from '../components/buttons/linkButton'

// <ErrorPage title='404' description='ページが見つかりません' buttonLabel='戻る' linkTo='/'/>

const DESTINATIONS = {
  リスト: '/list',
  タウン: `${import.meta.env.VITE_DIGITANE_ONLINE_URL}/s/`,
} as const

export interface ErrorPageProps {
  title: string
  description: string
  buttonLabel?: string
  linkTo?: keyof typeof DESTINATIONS
}

export const ErrorPage = ({
  title,
  description,
  buttonLabel,
  linkTo,
}: ErrorPageProps) => {
  return (
    <div className="error-page-wrapper">
      <HeaderMenu type="error" />
      <div className="errorPageContainer">
        <h1 className="errorTitle">{title}</h1>
        <p
          className="errorDescription"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {linkTo ?
          <LinkButton href={DESTINATIONS[linkTo]}>
            {buttonLabel ?? `${linkTo}へもどる`}
          </LinkButton>
        : null}
      </div>
    </div>
  )
}
